import { withTranslation } from 'react-i18next'
import Settings from './Settings'

export default withTranslation()(Settings)
